import { compact } from 'lodash';
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';

import { ButtonIconCircle } from 'base-components';
import { px2rem } from 'decisiv-ui-utils';

import Popover, { PopoverTarget, PopoverContent } from 'elements/Popover';

import AddNewMenuList from './AddNewMenuList';

import { ADD_NEW_MENU_ITEMS } from './constants';

class AddNew extends Component {
  state = {
    popoverVisible: false,
  }

  handlePopoverHide = () => {
    this.setState({ popoverVisible: false });
  }

  togglePopoverVisibility = () => {
    this.setState(prevState => ({ popoverVisible: !prevState.popoverVisible }));
  }

  render() {
    const buttonActive = this.state.popoverVisible && 'active';

    return (
      <Popover
        position="bottom"
        onHide={this.handlePopoverHide}
      >
        <PopoverTarget>
          <ButtonIconCircle
            modifiers={compact([buttonActive])}
            onClick={this.togglePopoverVisibility}
          >
            <FontAwesome name="plus" style={{ lineHeight: px2rem(31) }} />
          </ButtonIconCircle>
        </PopoverTarget>
        <PopoverContent>
          <AddNewMenuList menuItems={ADD_NEW_MENU_ITEMS} />
        </PopoverContent>
      </Popover>
    );
  }
}

export default AddNew;



// WEBPACK FOOTER //
// ./components/TopNav/AddNew/index.js